module.exports = __webpack_public_path__ + "media/images/hero_bg-8f3c3848b77b0386a27482292c54b4aa.svg";